// Catalog data
export const CATEGORIES = [
  "Mac",
  "iPhone",
  "iPad",
  "Displays",
  "AirPods",
  "Apple TV",
  "Accessories",
];

export const PART_NAMES = [
  "Whole Unit",
  "Full Dead Unit",
  "Partially Working Unit",
  "Display/Screen",
  "Top Case (Keyboard + Trackpad)",
  "Battery",
  "WiFi Module",
  "Motherboard (MLB)",
  "Speakers",
  "Microphone",
  "Power Supply/Adapter",
  "Housing/Chassis",
  "Other",
];

export const CONDITIONS = [
  "Working (Fully Functional)",
  "Partially Working (Some Issues)",
  "Dead/For Parts Only",
];

const CURRENT_YEAR = new Date().getFullYear();
export const YEARS = Array.from({ length: CURRENT_YEAR - 2007 + 1 }, (_, i) => CURRENT_YEAR - i);

// TestID namespace
export const TID = {
  home: {
    hero: "home-hero",
    cta: "home-cta-list",
    ctaBrowse: "home-cta-browse",
    search: "home-search",
    searchBtn: "home-search-btn",
  },
  nav: {
    logo: "nav-logo",
    browse: "nav-browse",
    sell: "nav-sell",
    chats: "nav-chats",
    login: "nav-login",
    profile: "nav-profile",
    logout: "nav-logout",
  },
  browse: {
    grid: "browse-grid",
    card: (id) => `listing-card-${id}`,
    cardLink: (id) => `listing-card-link-${id}`,
    filterCategory: "filter-category",
    filterCondition: "filter-condition",
    filterSort: "filter-sort",
    filterCountry: "filter-country",
    search: "browse-search",
  },
  create: {
    images: "create-images",
    aiSuggest: "create-ai-suggest",
    category: "create-category",
    modelNumber: "create-model-number",
    year: "create-year",
    part: "create-part",
    partCustom: "create-part-custom",
    condition: "create-condition",
    description: "create-description",
    price: "create-price",
    currency: "create-currency",
    city: "create-city",
    country: "create-country",
    submit: "create-submit",
  },
  detail: {
    chatCta: "detail-chat-cta",
    sellerCard: "detail-seller-card",
    report: "detail-report",
    image: (i) => `detail-image-${i}`,
  },
  chat: {
    list: "chat-list",
    item: (id) => `chat-item-${id}`,
    input: "chat-input",
    send: "chat-send",
    banner: "chat-safety-banner",
  },
};
